import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SelectedReportDetailsService {
  private _clearDisplayedHierarchyItems: BehaviorSubject<boolean> = new BehaviorSubject(true);
  public clearDisplayedHierarchyItems$ = this._clearDisplayedHierarchyItems.asObservable();

  constructor() {}

  public setClearDisplayedHierarchyItems(clearData: boolean) {
    this._clearDisplayedHierarchyItems.next(clearData);
  }
}
